import { DataType } from '@splunk/visualization-encoding/src/DataPrimitive';
import { DataPoint } from '@splunk/visualization-encoding/src/DataPoint';
import { DataFrame } from '@splunk/visualization-encoding/src/DataFrame';
import { DataSeries } from '@splunk/visualization-encoding/src/DataSeries';
import { DataSeriesLite } from '@splunk/visualization-encoding/src/DataSeriesLite';

export interface Dimensions {
    [key: string]: IDimension;
}

export type IDimension<T extends DataType = DataType> =
    | DataPoint<T>
    | DataSeries<T>
    | DataSeriesLite<T>
    | DataFrame<T>;
